<template>
  <NuxtLink
    :to="item.relatedLink"
    :target="item.relatedLink.startsWith(baseURL) ? '_self' : '_blank'"
    class="banner-item"
  >
    <div
      class="text-container"
      v-html="item.title"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { HomeBannerModel } from '~/types/model/home/banner.model'

interface IProps {
  item: HomeBannerModel
}

const props = defineProps<IProps>()

const desktopThumbnail = computed(() => {
  return `url(${props.item.desktopThumbnail})`
})

const mobileThumbnail = computed(() => {
  return `url(${props.item.mobileThumbnail})`
})

const baseURL = computed(() => import.meta.env.VITE_APP_BASE_URL ?? '')
</script>

<style scoped lang="scss">
.banner-item {
  @apply relative overflow-hidden h-80 w-full text-left;
  background: {
    position: center;
    image: v-bind(desktopThumbnail);
    repeat: no-repeat;
    size: cover;
  }

  @include mobile {
    @apply h-40;
    background: {
      image: v-bind(mobileThumbnail);
    }
  }

  // TODO: 텍스트 정렬(왼쪽, 가운데 등등)도 인터널에서 설정? 가운데면 걱정 없긴 한데 왼쪽이나 오른쪽은 양 옆 최소 기준이 있는지?
  .text-container {
    @apply absolute top-1/2 flex -translate-y-1/2 flex-col font-bold leading-normal;
    left: min(320px, 15%);
    width: calc(100% - min(320px, 15%));

    :deep(h2) {
      @apply mb-8 mt-2 text-[40px] w-[750px] #{!important};
    }

    :deep(h3) {
      @apply text-primary;

      @include mobile {
        @apply text-[10px];
      }
    }

    @include mobile {
      @apply left-1/2 -translate-x-1/2 items-center text-center break-words;
      width: min(70%, 350px);

      :deep(h2) {
        @apply max-w-full mb-2 mt-1 text-lg #{!important};
      }
    }
  }
}
</style>